import React, { useState, useEffect } from "react"
import {
    Col,
    Card,
    Nav,
    CardBody,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Table,
    Row,
    Container,
    CardText,
} from "reactstrap"
import classnames from "classnames"
import { Link } from "react-router-dom"
import DashboardService from "services/Provider/DashboardService"
import { SuccessOk } from "configs/statusCode";
import Paginator from "./Paginator"
import { providerPrefix } from "configs/routePrefix"
import { AvForm, AvField } from 'availity-reactstrap-validation'

const Activities = () => {
    const [activeTab, setactiveTab] = useState("1")
    const dashboardService = new DashboardService()
    const [activities, setAactivities] = useState([])
    const [month, setMonth] = useState("")
    const [shouldGetData, setShouldGetData] = useState(false)
    const [filtersParams, setFilterParams] = useState({
        activities: 1
    })
    const [pageOptions, setPageOptions] = useState({
        sizePerPage: 10,
        totalSize: 1,
    });

    useEffect(() => {
        const params = {
            activities: 1
        }
          if (month.length > 0) {
            params["date"] = month
            setFilterParams({ ...params })

        }else{
            setFilterParams({ ...params })

        }
    }, [month]);

    return (

        <React.Fragment>
            <div className="account-pages my-5 pt-5">
                <Container className="px-lg-3">
                    <Row className="pb-4">
                        <Col>
                            <CardText tag="h4" className="fw-bold"><Link to={`${providerPrefix}/dashboard`}>
                                <i className="fa fa-arrow-left"></i></Link> Activities</CardText>
                            {/* <CardText tag="p">Track the movement of members of the system</CardText> */}
                            <Card>
                                <CardBody>
                                    <div className="float-end mb-2">
                                        <AvForm>
                                            <AvField
                                                name={"date"}
                                                bsSize="lg"
                                                value={month}
                                                onChange={e => setMonth(e.target.value)}
                                                type="month"
                                            />
                                        </AvForm>
                                    </div>
                                    <h4 className="card-title my-2">Statistics</h4>
                                    {false ? <Nav pills className="bg-light rounded" role="tablist">
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === "1" })}
                                                onClick={() => {
                                                    setactiveTab("1")
                                                }}
                                            >
                                                All
                                </NavLink>
                                        </NavItem>

                                    </Nav> : null}
                                    <TabContent activeTab={activeTab} className="mt-4">
                                        <TabPane tabId="1">
                                            <div>
                                                {activities ?.length ? activities ?.map((activity, index) => {
                                                    return (
                                                        <div className="border p-3" key={index}>
                                                            <CardText tag="p" className="text-muted mb-2">{activity.date}</CardText>
                                                            <CardText tag="p" className="text-muted">
                                                                {activity.title}
                                                            </CardText>
                                                        </div>
                                                    )
                                                })
                                                    : null}
                                            </div>
                                        </TabPane>
                                        {/* <TabPane tabId="2">
                                            <div>
                                                <div className="border-bottom p-3">
                                                    <CardText tag="h6" className="font-font-size-18">Akram Magdy <span className="badge bg-light font-size-12 text-success">Admin</span></CardText>
                                                    <CardText tag="p" className="text-muted mb-2">12 Mar, 2020</CardText>
                                                    <CardText tag="p" className="text-muted">
                                                        Added a new compound <span className="fw-bold text-decoration-underline text-dark">Prime Avenu</span>
                                                    </CardText>
                                                </div>
                                            </div>
                                        </TabPane>
                                        <TabPane tabId="3">
                                            <div>
                                                <div className="border-bottom p-3">
                                                    <CardText tag="h6" className="font-font-size-18">Akram Magdy <span className="badge bg-light font-size-12 text-success">Admin</span></CardText>
                                                    <CardText tag="p" className="text-muted mb-2">12 Mar, 2020</CardText>
                                                    <CardText tag="p" className="text-muted">
                                                        Added a new compound <span className="fw-bold text-decoration-underline text-dark">Prime Avenu</span>
                                                    </CardText>
                                                </div>
                                            </div>
                                        </TabPane> */}
                                    </TabContent>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-end">
                        <Col className="d-flex justify-content-end" md={8} sm={12}>
                            <Paginator
                                service={dashboardService}
                                pageOptions={pageOptions}
                                setData={(data) => setAactivities([...data])}
                                setPageOptions={setPageOptions}
                                filtersParams={filtersParams}
                                shouldGetData={shouldGetData}
                                setShouldGetData={setShouldGetData}
                            />
                        </Col>
                    </Row >
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Activities
